import React from "react";
import { StringWidget } from "./StringWidget";

export function CodeWidget(props) {
  return (
    <StringWidget
      isBaseWidgetFor="CodeWidget"
      useMonospaceFont={true}
      {...props}
    />
  );
}